// DeleteDialog.tsx

import React, {useState} from 'react';
import {Dialog, DialogContent, DialogHeader} from 'src/ui-components/Modal';
import {Button} from 'src/ui-components/Button/button';
import {useAppDispatch} from 'src/store';

interface DeleteDialogProps {
    open: boolean;
    fileName: string;
    onClose: () => void;
    onConfirm: () => void;
}

const DeleteDialog: React.FC<DeleteDialogProps> = ({open, fileName, onClose, onConfirm}) => {
    const [deleteFileUid, setDeleteFileUid] = useState('');
    const [deleteFileName, setDeleteFileName] = useState('');
    const dispatch = useAppDispatch();

    return (
        <Dialog open={open}>
            <DialogContent className='w-[300px] md:w-[686px]' onClose={onClose}>
                <DialogHeader>
                    <span className='text-[18px] font-[600] text-[#101828]'> Delete File?</span>
                </DialogHeader>
                <span className='text-[14px] font-[400] text-[#475467]'>
                    Are you sure you would like to delete{' '}
                    <span className='text-[#000000 text-[14px] font-[700]'>{fileName}.</span> This action cannot be
                    undone.
                </span>
                <div className='mb-[24px] mt-[2rem] flex gap-[18px]'>
                    <Button variant='secondary' size='lg' className='w-full' onClick={onClose}>
                        Cancel
                    </Button>
                    <Button size='lg' className='w-full' onClick={onConfirm}>
                        Confirm
                    </Button>
                </div>
            </DialogContent>
        </Dialog>
    );
};

export default DeleteDialog;
